import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'volumeDay',
})
export class VolumeDayPipe implements PipeTransform {
  transform(value: string | number | any, ...args: unknown[]): unknown {
    if (!value) {
      return '-';
    }

    const suffixes = ['', 'K', 'M', 'B', 'T']; //establecemos un array de sufijos,
    //los cuales representan: Menor que Mil (""), Miles (K), Millones (M), Billones (B) y Trillones (T)

    let suffixNum = 0; //Se declara suffixNum para establecer la posición del Array

    //El siguiente While nos dice "Mientras el valor es mayor o igual a 1000" entonces divídelo entre mil
    //y suma uno a "suffixNum" (así va estableciendo la posición del array)
    while (value >= 1000) {
      value /= 1000;
      suffixNum++;
    }

    //A nuestro valor le especificamos una "precisión de 3", lo que hace es que redondeada a una precision de dígitos significativos.
    value = value.toPrecision(3);

    //Por último concatenamos el sufijo establecido anteriormente
    value += suffixes[suffixNum];
    return value;
  }
}
